import { render, staticRenderFns } from "./currentLocation.vue?vue&type=template&id=1629cb0c"
import script from "./currentLocation.vue?vue&type=script&lang=ts"
export * from "./currentLocation.vue?vue&type=script&lang=ts"
import style0 from "./currentLocation.vue?vue&type=style&index=0&id=1629cb0c&prod&lang=css"
import style1 from "./currentLocation.vue?vue&type=style&index=1&id=1629cb0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports